import { type Enum } from '@webapp/infrastructure/types/Enum'

export const Teams = {
  GRANDFATHERED: 'GRANDFATHERED',
  TEAM_PURCHASING: 'TEAM_PURCHASING',
  TEAM_AP: 'TEAM_AP',
  TEAM_PAYMENTS: 'TEAM_PAYMENTS',
  TEAM_INTEGRATIONS: 'TEAM_INTEGRATIONS',
  TEAM_CLC: 'TEAM_CLC',
  TEAM_ARCHITECTURE: 'TEAM_ARCHITECTURE',
  TEAM_DEVSECOPS: 'TEAM_DEVSECOPS',
  TEAM_MHAUS: 'TEAM_MHAUS',
  PUNCHOUT_BETAS: 'PUNCHOUT_BETAS',
  DESIGN_SYSTEM: 'DESIGN_SYSTEM',
  TEAM_PLATFORM: 'TEAM_PLATFORM',
  TEAM_DATA: 'TEAM_DATA',
  TEAM_VENDORS: 'TEAM_VENDORS',
} as const

export type Teams = Enum<typeof Teams>
